import { render, staticRenderFns } from "./VoiceVisualizer0203OFF.vue?vue&type=template&id=7f98d06a&scoped=true&"
import script from "./VoiceVisualizer0203OFF.vue?vue&type=script&lang=js&"
export * from "./VoiceVisualizer0203OFF.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=7f98d06a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98d06a",
  null
  
)

export default component.exports